<template>
	<b-modal id="modal-recalculoNota" @ok="handleEnvio">
		<template v-slot:modal-title>
			<label>Recalculo de nota</label>
		</template>
		<div class="media-body">
			<b-alert v-if="!jsonEstadoNota" show variant="warning"
				>Este alumno ha sufrido un cambio en sus respuestas, es
				necesario un recálculo en su nota final.</b-alert
			>
			<div class="media-body">
				<h5 class="header-title mb-4">Información Personal</h5>
				<label>Rut: {{ infoAlumno.numeroDocumento }}</label
				><br />
				<label
					>Nombre: {{ infoAlumno.nombre }}
					{{ infoAlumno.apellido }}</label
				><br />
				<label>Email: {{ infoAlumno.email }}</label>
				<br />
				<label
					>Evaluacion:
					{{ jsonEvaluacionAlumno.nombreEvaluacion }}</label
				>
			</div>
			<hr />
			<div class="media-body">
				<h5 class="header-title mb-4">Detalles Evaluación</h5>
				<table class="table table-striped table-hover border">
					<tbody>
						<tr>
							<td>Cantidad Preguntas</td>
							<td>{{ jsonEvaluacionAlumno.totalPregunta }}</td>
						</tr>
						<tr>
							<td>Preguntas Correctas</td>
							<td>
								{{ jsonEvaluacionAlumno.respuestasCorrectas }}
							</td>
						</tr>
						<tr>
							<td>Preguntas Incorrectas</td>
							<td>
								{{ jsonEvaluacionAlumno.respuestasIncorrectas }}
							</td>
						</tr>
						<tr>
							<td>Nota Actual</td>
							<td>
								{{
									precise_round(
										jsonEvaluacionAlumno.notafinal,
										1
									)
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--  <b-button block variant="primary">Reinicio Control</b-button> -->
		</div>
		<template v-slot:modal-footer="{ ok }">
			<b-button block variant="primary" @click="ok()">
				Aceptar
			</b-button>
		</template>
		<toast ref="toast" />
	</b-modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toast from "@/components/toastComponent";
export default {
	components: {
		toast,
	},
	data() {
		return {
			infoAlumno: {},
			idEvaluacion: "",
		};
	},
	computed: {
		...mapState("evaluacionAlumno", ["jsonEvaluacionAlumno"]),
		...mapState("evaluacion", ["jsonEstadoNota"]),
	},
	methods: {
		...mapActions("evaluacion", ["updateEstadoNota"]),
		handleEnvio(bvModalEvt) {
			// Prevent modal from closing
			bvModalEvt.preventDefault();
			this.updateEvaluacion();
		},
		async updateEvaluacion() {
			const form = {
				idNota: this.jsonEvaluacionAlumno.idNota,
				idAlumno: this.infoAlumno.idAlumno,
				idEvaluacion: this.idEvaluacion,
				idLogeado:JSON.parse(window.atob(localStorage.getItem('usuarioDB'))).idAlumno
			};
			const data = await this.axios.post("api/recalculoNota", form);

			if (data.data.msg == "notaActualizada") {
				this.jsonEvaluacionAlumno.notafinal = data.data.nuevaNota;
				//contar las correctas
				let contadorBuenas = 0;
				let contadorMalas = 0;
				if(data.data.controlByAlumno != undefined){
					data.data.controlByAlumno.map((pregunta)=>{
                        if(pregunta.correcta == null){
                            contadorMalas += 1;
						}else{
							contadorBuenas += 1;
						}
					});
				}

				this.jsonEvaluacionAlumno.respuestasCorrectas = contadorBuenas;
				this.jsonEvaluacionAlumno.respuestasIncorrectas = contadorMalas;
 
				const arrayToast = {
					msg: `Se ha actualizado la nota a: ${this.precise_round(data.data.nuevaNota,1)}`,
					title: `Exito en el cambio nota`,
					variant: `success`,
				};
				this.$refs.toast.makeToast(arrayToast);
				this.updateEstadoNota(true);
			}

			/* this.axios.post("api/recalculoNota", form).then((res) => {
				console.log(res.data);
				if (res.data.msg == "notaActualizada") {
					this.jsonEvaluacionAlumno.notafinal = res.data.nota;

					const arrayToast = {
						msg: `Se ha actualizado la nota a: ${this.precise_round(
							res.data.nota,
							1
						)}`,
						title: `Exito en el cambio nota`,
						variant: `success`,
					};
					this.$refs.toast.makeToast(arrayToast);
					this.updateEstadoNota(true);
				}
			}); */
		},
		getInfoModal(arrayAlumno) {
			this.infoAlumno = arrayAlumno.infoAlumno;
			this.idEvaluacion = arrayAlumno.idEvaluacion;
		},
		precise_round(num, decimals) {
			var t = Math.pow(10, decimals);
			return (
				Math.round(
					num * t +
						(decimals > 0 ? 1 : 0) *
							(Math.sign(num) * (10 / Math.pow(100, decimals)))
				) / t
			).toFixed(decimals);
		},
	},
};
</script>
